"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const products = e.data;
    window.digitalData.cart = {};
    window.digitalData.cart.item = [];
    window.digitalData.product = [];
    if (products) {
        products.forEach((productItem, i) => {
            let arr = {};
            arr = {
                productInfo: {
                    productID: productItem.identifierValue || 'NA',
                    productName: productItem.productName || 'NA',
                    brand: productItem.brandName || 'NA',
                    price: productItem.price || 'NA',
                    quantity: productItem.qty || 'NA',
                    sku: productItem.identifierValue || 'NA',
                },
                category: {
                    primaryCategory: productItem.category || 'NA',
                },
                pCAT: {
                    name: '',
                    level: '',
                },
                attributes: {
                    productVariants: productItem.size || 'NA',
                    listPosition: i + 1,
                },
            };
            window.digitalData.cart.item.push(arr);
            window.digitalData.product.push(arr);
        });
    }
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.eventInfo = {
        type: window.ctConstants.addtoCart,
        eventLabel: 'Add to cart',
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.conversion,
    };
    analyticsEvent.attributes = { nonInteractive: { nonInteraction: 1 } };
    analyticsEvent.subcategory = 'Lead';
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
